/**
 * #90 (Marlene, 10.09.2026): „auf dieser Übersicht wäre auch gut, wenn man
 * einen kleinen Status so wie beim KI Telefon hat, wo man sieht ob etwas
 * abschließend bearbeitet wurde oder noch offen ist, oder auf Rückmeldung
 * gewartet wird."
 *
 * 🔑 „wartet auf Rückmeldung" gibt es in `email_log` nicht — der Status kennt
 * nur new / reviewed / done. Hergeleitet wird er deshalb aus dem, was
 * tatsächlich feststeht: wir haben geantwortet oder weitergeleitet, und die
 * Sache ist trotzdem noch nicht abgehakt. Dann liegt der Ball beim anderen.
 *
 * Bewusst NICHT über ein Zeitfenster („seit 3 Tagen keine Antwort") — das wäre
 * eine zweite Wahrheit neben dem Thread und würde bei jeder Kundenantwort
 * hinterherhinken.
 */
export type MailStand = "erledigt" | "wartet" | "offen"

export function mailStand(e: {
  status?: string | null
  is_replied?: boolean | null
  is_forwarded?: boolean | null
}): MailStand {
  if ((e.status || "") === "done") return "erledigt"
  if (e.is_replied || e.is_forwarded) return "wartet"
  return "offen"
}

export const STAND_TEXT: Record<MailStand, string> = {
  erledigt: "erledigt",
  wartet: "wartet auf Rückmeldung",
  offen: "offen",
}

/** Farben wie in der KI-Telefon-Liste: grün fertig, orange offen, grau wartend. */
export const STAND_FARBE: Record<MailStand, { bg: string; fg: string }> = {
  erledigt: { bg: "rgba(5,150,105,.12)", fg: "#059669" },
  wartet: { bg: "rgba(44,44,42,.08)", fg: "var(--text-secondary)" },
  offen: { bg: "rgba(217,119,6,.12)", fg: "#b45309" },
}
